<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="name">Улица</label>
    <input
      type="text"
      class="form-control"
      id="name"
      placeholder="Введите улицу"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)"
    >
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'address-name-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// AddressName.vue?1de7ec99